export enum NewsBarUnit {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}

export enum NewsSourceType {
  NEWS_ARTICLE = "news_article",
  PRESS_RELEASE = "press_release",
}

export enum DevelopmentType {
  FINANCIAL_RESULTS = "financial_results",
  GUIDANCE_OR_OUTLOOK = "guidance_or_outlook",
  STRATEGY_CHANGE = "strategy_change",
  OPERATIONAL_CHANGE = "operational_change",
  COMMERCIAL_DEVELOPMENT = "commercial_development",
  TRANSACTION = "transaction",
  FINANCING_OR_CAPITAL_RETURN = "financing_or_capital_return",
  LEADERSHIP_OR_BOARD_CHANGE = "leadership_or_board_change",
  POLICY_OR_COMMITMENT = "policy_or_commitment",
  PRODUCT_OR_SERVICE_CHANGE = "product_or_service_change",
  WORKFORCE_CHANGE = "workforce_change",
  REGULATORY_CHANGE = "regulatory_change",
  INVESTIGATION = "investigation",
  ENFORCEMENT = "enforcement",
  LITIGATION = "litigation",
  INCIDENT = "incident",
  CONTROVERSY_OR_ALLEGATION = "controversy_or_allegation",
  DISCLOSURE = "disclosure",
  OTHER = "other",
}

export enum EvidenceDirection {
  POSITIVE = "positive",
  NEGATIVE = "negative",
  MIXED = "mixed",
  NEUTRAL = "neutral",
  UNCLEAR = "unclear",
}

export enum EvidenceRole {
  CONTEXT = "context",
  COMPANY_CLAIM = "company_claim",
  INTENT_OR_COMMITMENT = "intent_or_commitment",
  ACTION_OR_IMPLEMENTATION = "action_or_implementation",
  OBSERVED_OUTCOME = "observed_outcome",
  EXTERNAL_FINDING = "external_finding",
  ALLEGATION_OR_CONCERN = "allegation_or_concern",
}

export enum CompanyDimension {
  BUSINESS_MODEL = "business_model",
  STRATEGY = "strategy",
  FINANCIAL_PERFORMANCE = "financial_performance",
  OPERATIONS = "operations",
  CAPITAL_ALLOCATION = "capital_allocation",
  GOVERNANCE = "governance",
  REGULATORY_LEGAL = "regulatory_legal",
}

export enum FinancialChannel {
  REVENUE = "revenue",
  DEMAND_VOLUME = "demand_volume",
  PRICING = "pricing",
  COST = "cost",
  MARGIN = "margin",
  CAPEX = "capex",
  ASSET_VALUE = "asset_value",
  LIABILITY_OR_PROVISION = "liability_or_provision",
  CASH_FLOW = "cash_flow",
  FINANCING_COST_OR_ACCESS = "financing_cost_or_access",
  VALUATION_OR_MARKET_PRICE = "valuation_or_market_price",
}
